import React, { useState } from "react";
import TopCard from "../../components/UserSideComponents/TopCard";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  return (
    <div className="w-full">
      <TopCard />

      <div className="grid grid-cols-1 md:grid-cols-2 bg-[#F7F1EC] px-6 md:px-16 py-14 gap-10">
        {/* LEFT SECTION */}
        <div className="flex flex-col gap-10">
          {/* Heading */}
          <div className="max-w-lg">
            <span className="text-orange-500 font-philosopher text-sm">
              — Contact us
            </span>
            <h1 className="font-philosopher text-4xl font-bold text-gray-900 mt-2">
              Contact With Us
            </h1>
            <p className="font-robotoflex text-gray-500 mt-4 leading-relaxed">
              Rapidiously myocardinate cross-platform intellectual capital
              after the model. Appropriately create interactive
              infrastructures after maintenance.
            </p>
          </div>

          {/* Info Blocks */}
          <div className="flex flex-col gap-8">
            {/* Phone */}
            <div className="flex items-center gap-5">
              <div className="p-4 bg-white rounded-full shadow-sm">
                <FaPhoneAlt className="text-orange-500 text-xl" />
              </div>
              <div>
                <p className="text-sm text-gray-400">Call Us Now</p>
                <p className="font-philosopher text-xl text-gray-900">
                  +91-83388 22566
                </p>
              </div>
            </div>

            <div className="w-full h-px bg-gray-300" />

            {/* Email */}
            <div className="flex items-center gap-5">
              <div className="p-4 bg-white rounded-full shadow-sm">
                <MdEmail className="text-orange-500 text-xl" />
              </div>
              <div>
                <p className="text-sm text-gray-400">Send Email</p>
                <p className="font-philosopher text-xl text-gray-900">
                  sakhibyshweta@gmail <br /> .com
                </p>
              </div>
            </div>

            <div className="w-full h-px bg-gray-300" />

            {/* Location */}
            <div className="flex items-center gap-5">
              <div className="p-4 bg-white rounded-full shadow-sm">
                <MdLocationOn className="text-orange-500 text-xl" />
              </div>
              <div>
                <p className="text-sm text-gray-400">Our Location</p>
                <p className="font-philosopher text-xl text-gray-900">
                  PLOT - 12, east, Ashok Nagar, Bhubaneswar, Odisha 751009
                </p>
                {/* <p className="font-philosopher text-xl text-gray-900">
                  Bhubaneswar - Cuttack - Rourkela
                </p> */}
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT FORM SECTION */}
        <div className="bg-[#272727] p-10">
          <h2 className="font-philosopher text-white text-2xl font-bold text-center uppercase mb-8">
            Get In Touch
          </h2>

          <form className="flex flex-col gap-4">
            <input
              type="text"
              placeholder="Your Name"
              className="bg-transparent border border-gray-600 p-4 text-white placeholder-gray-400 focus:outline-none"
            />

            <input
              type="email"
              placeholder="Enter Your Email"
              className="bg-transparent border border-gray-600 p-4 text-white placeholder-gray-400 focus:outline-none"
            />

            <select className="bg-transparent border border-gray-600 p-4 text-gray-400 focus:outline-none">
              <option>Select Subject</option>
              <option>Subject One</option>
              <option>Subject Two</option>
              <option>Subject Three</option>
            </select>

            <textarea
              rows="4"
              placeholder="Write Message"
              className="bg-transparent border border-gray-600 p-4 text-white placeholder-gray-400 focus:outline-none resize-none"
            />

            <button className="mt-4 bg-orange-500 hover:bg-orange-600 text-white font-philosopher uppercase font-bold py-4 transition">
              Send Message
            </button>
          </form>
        </div>
      </div>

      {/* GOOGLE MAP SECTION */}
      <div className="w-full px-6 md:px-16 py-14 overflow-hidden bg-[#F7F1EC]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.863961786599!2d85.83729347421699!3d20.264475913591696!2m3!1f0!2f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a7e94437c4ad%3A0xde7e03f882197a24!2sSAKHI%20HOME%20SALON!5e0!3m2!1sen!2sin!4v1772425656908!5m2!1sen!2sin"
          className="w-full min-h-[350px] md:min-h-[450px] lg:min-h-[500px] rounded-xl shadow-lg"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Sakhi Home Salon Location"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
